import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
export default [{
  path: '/sign_in_enter_old',
  // name: ROUTE_NAME.SIGN_IN_ENTER,
  meta: {
    title: '打卡',
    popup: 'countdown',
    needLogin: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "sign_in" */
      '@/pages/signIn/enter.vue'),
      loading: Loading
    };
  }
}, {
  path: '/sign_in',
  name: ROUTE_NAME.SIGN_IN,
  meta: {
    title: '打卡',
    // needBinding: true,
    needLoginNext: true,
    needLogin: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "sign_in" */
      '@/pages/signIn/signIn.vue'),
      loading: Loading
    };
  }
}, {
  path: '/sign_in_enter',
  name: ROUTE_NAME.SIGN_IN_ENTER,
  meta: {
    title: '打卡',
    // needBinding: true,
    needLoginNext: true,
    needLogin: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "sign_in" */
      '@/pages/signIn/new_signin.vue'),
      loading: Loading
    };
  }
}, {
  path: '/sign_in_record/:year?/:month?',
  name: ROUTE_NAME.SIGN_IN_RECORD,
  meta: {
    title: '打卡记录',
    disableShare: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "sign_in" */
      '@/pages/signIn/record.vue'),
      loading: Loading
    };
  }
}, {
  path: '/sign_in_result/:signInId',
  name: ROUTE_NAME.SIGN_IN_RESULT,
  meta: {
    title: '打卡结果',
    disableShare: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "sign_in" */
      '@/pages/signIn/result.vue'),
      loading: Loading
    };
  }
}, {
  path: '/sign_in/dataView',
  name: ROUTE_NAME.DATA_VIEW,
  meta: {
    title: '数据统计',
    disableShare: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "sign_in" */
      '@/pages/signIn/dataView.vue'),
      loading: Loading
    };
  }
}];